"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 数据格式相关
 */
var format = {
    /**
     * 运单号合法性校验
     * @param waybillNo 运单号
     */
    isSFNo: function (waybillNo) {
        if (waybillNo === void 0) { waybillNo = ''; }
        return typeof waybillNo === 'string' && /^(([0-9]{12})|(sf[0-9]{13}))$/i.test(waybillNo);
    },
    /**
     * 运单号分隔
     * @param {*} waybillNo 运单号
     * @param {*} n 每一段的长度默认是三
     */
    waybillNoGrouping: function (waybillNo, n) {
        if (waybillNo === void 0) { waybillNo = ''; }
        if (n === void 0) { n = 3; }
        var reg = new RegExp("\\w{1," + n + "}(?=(\\d{" + n + "})+$)", 'g');
        return waybillNo.replace(/\s/, '').replace(reg, '$& ');
    },
    /**
     * 化成标准的运单号，小写sf换成SF, 如果是13位单号则自动补全SF
     * @param {*} waybillNo 运单号
     * @param {*} toUpper 是否转成大写的SF 默认转
     */
    normalizeSFNo: function (waybillNo, toUpper) {
        if (toUpper === void 0) { toUpper = true; }
        var temp = waybillNo.replace(/[^sf0-9]/gi, '');
        return toUpper ? temp.toUpperCase() : temp;
    },
    /**
     * 电话号码分组处理
     * @param {*} str 待处理
     * @param {*} n 分组长度
     * @author	847789
     * @returns	'133 3333 3333'、'0755-1234 5678'
     */
    telGrouping: function (str, n) {
        if (n === void 0) { n = 4; }
        return str.replace(new RegExp("([0-9]{" + n + ",})", 'g'), function (x) {
            return x
                .split('')
                .reverse()
                .map(function (item, index) {
                return index > 0 && index % n === 0 ? item + " " : item;
            })
                .reverse()
                .join('');
        });
    },
    /**
     * 生成UUID
     * @param	len UUID的长度
     * @param	radix 进制格式 2、10、16
     * @returns {string}
     * @constructor
     */
    UUID: function (len, radix) {
        if (len === void 0) { len = 32; }
        if (radix === void 0) { radix = 16; }
        var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
        var uuid = new Array(len).fill('');
        for (var i = 0; i < len; i++) {
            var index = Math.floor(0 || Math.random() * radix);
            uuid[i] = chars[index];
        }
        return uuid.join('');
    },
    /**
     * 生成n位随机数，默认6位
     * @returns {string}
     */
    random6: function (n) {
        if (n === void 0) { n = 6; }
        return Math.random()
            .toString()
            .substr(2, n);
    },
    /**
     * 电话号码脱敏处理
     * @description 从倒数第m位开始往前连续n位进行电话屏蔽,如果号码位数小于m+n-1位且大于m-1位，同样只保留后m-1位，如果小于或等于m-1位则全部隐藏
     * @param {string} tel 电话号码
     * @param {[type]} m 从倒数第m位开始屏蔽，默认为5
     * @param {[type]} n 连续n位屏蔽，默认为4
     * @return {string} 加密后的电话号码
     */
    encrypted: function (tel, m, n) {
        if (m === void 0) { m = 5; }
        if (n === void 0) { n = 4; }
        if (typeof tel !== 'string' || !tel)
            return '';
        var len = tel.length;
        if (len < m) {
            return tel
                .split('')
                .map(function () { return '*'; })
                .join('');
        }
        return tel
            .split('')
            .reverse()
            .map(function (item, index) {
            return index >= m - 1 && index < m + n - 1 ? '*' : item;
        })
            .reverse()
            .join('');
    },
    /**
     * 将标准对象转换为url参数串
     * @param query
     */
    obj2str: function (query) {
        var _a = ['', '?'], str = _a[0], quote = _a[1];
        if (typeof query !== 'object' || !Object.keys(query).length)
            return str;
        for (var key in query) {
            str += "" + quote + key + "=" + query[key];
            quote = '&';
        }
        return str;
    },
    /**
     * 删除对象中为空的属性
     */
    objectClearEmpty: function (obj) {
        var newObject = {};
        for (var item in obj) {
            if (obj[item] !== '' || Object.keys(obj[item]).length)
                newObject[item] = obj[item];
        }
        return newObject;
    },
    /**
     * 对象重组
     * @param {Object} o 源对象
     * @param {Array} format	期望的新对象所含字段
     * @see	o = {a: 1, b: 2, c: 3, d: 4}	format = ['a', 'b', ['x', 'd'], 'd']
     * @returns	{a: 1, b: 2, x: 4, d: 4}
     * @author	847789
     */
    objectReorganize: function (o, format) {
        if (!Array.isArray(format))
            return o;
        var newObject = {};
        format.forEach(function (item) {
            var _a;
            var _b = [item, item], from = _b[0], to = _b[1];
            if (Array.isArray(item))
                _a = [item[0], item[1]], from = _a[0], to = _a[1];
            newObject[from] = o[to] || '';
        });
        return newObject;
    }
};
exports.default = {
    name: 'utils-format',
    install: function (UIP) {
        UIP.checkModule('utils', 'format');
        UIP.utils.format = format;
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/utils-format/dist/index.js
// module id = wye5
// module chunks = 1